import {createAsyncThunk} from '@reduxjs/toolkit';
import {filtersApi} from 'api';
import {IEntityBase} from 'models';
import {toastNotificationManager} from 'toast-notifications';
import {prefix} from './config';

export const fetchSkillsAndBehaviorsThunk: any = createAsyncThunk<IEntityBase[]>(
  `${prefix} fetchSkillsAndBehaviors`,
  async (_, {rejectWithValue, dispatch}) => {
    try {
      const {parsedBody} = await filtersApi.getSkillsAndBehaviors();
      return parsedBody;
    } catch (error) {
      dispatch(
        toastNotificationManager.createErrorToastAction(
          error.parsedBody || error.statusText || 'Failed to fetch skills and behaviors. Unknown error occurred.'
        )
      );
      return rejectWithValue(error);
    }
  }
);
